import { render, staticRenderFns } from "./RepxRepairStages.vue?vue&type=template&id=60abe4c9"
import script from "./RepxRepairStages.vue?vue&type=script&lang=js"
export * from "./RepxRepairStages.vue?vue&type=script&lang=js"
import style0 from "./RepxRepairStages.vue?vue&type=style&index=0&id=60abe4c9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports